import React, { FC } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

export interface Case {
  title: string;
  date: string;
  status: string;
  avatar?: string;
}

type Props = {
  cases: Case[];
};

const CasesList: FC<Props> = ({ cases }) => {
  return (
    <List sx={{ width: '100%', mt: 1 }} dense disablePadding>
      {cases.map(({ title, date, status, avatar }) => (
        <ListItem sx={{ px: 0, alignItems: 'flex-start' }} key={title}>
          <ListItemAvatar sx={{ py: 0.6 }}>
            <Avatar
              sx={{
                background: '#E2EDFE',
                border: '3px solid #fff',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
              }}
            >
              <Icon icon="carbon:document-blank" color="#000" fontSize={14} />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={title}
            secondary={
              <Box>
                <Typography fontSize={12} color="#3E3E3E" fontWeight={400}>
                  {date}
                </Typography>
                <Typography fontSize={12} color="#3E3E3E" fontWeight={400}>
                  {status}
                </Typography>
              </Box>
            }
            primaryTypographyProps={{ sx: { fontSize: 14, fontWeight: 500, color: '#456BD9', mb: 0.4 } }}
            secondaryTypographyProps={{ sx: { fontSize: 12, fontWeight: 400, color: '#3E3E3E' } }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default CasesList;
